/**
 * Dependencies.
 */
import Vue from 'vue';
import Vuex from 'vuex';
import { config } from 'vuex-module-decorators';

/**
 * Config.
 */
config.rawError = true;

/**
 * Use `Vuex`.
 */
Vue.use(Vuex);

/**
 * Store.
 */
const store = new Vuex.Store({
  strict: process.env.NODE_ENV === 'development'
});

/**
 * Export `store`.
 */
export default store;
